var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"round"},React.createElement("g",{"id":"large/navigation/header","transform":"translate(-1153.000000, -41.000000)","stroke":"#015294","strokeWidth":"2"},React.createElement("g",{"id":"Header"},React.createElement("g",{"id":"Search-field","transform":"translate(1140.000000, 27.000000)"},React.createElement("path",{"d":"M19.5,26 C16.4624339,26 14,23.5375661 14,20.5 C14,17.4624339 16.4624339,15 19.5,15 C22.5375661,15 25,17.4624339 25,20.5 C25,23.5375661 22.5375661,26 19.5,26 Z M24.5,24.4375 L32,31 L24.5,24.4375 Z","id":"Combined-Shape"}))))));
}

SearchIconInline.defaultProps = {"viewBox":"0 0 20 18","version":"1.1"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
